export function exactSubstringSearch(str: string, subStr: string) {
  const re = new RegExp(subStr + "$", "i")
  return Boolean(~str.search(re))
}

export function getPluralRule(value: number, lang: string) {
  const langLib = {
    de: "de-DE",
    en: "en-US",
    fr: "fr-FR",
    ru: "ru-RU",
  }
  return new Intl.PluralRules(langLib[lang]).select(value)
}
